import { ChangeDetectionStrategy, Component, computed, forwardRef, input, signal, WritableSignal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { RessourcesModule } from '@ressources/client/ressources.module';
import { FileService } from '@shared/client/services/file.service';
import { FormService } from '@shared/client/services/form.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ImageSelectorComponent),
        },
    ],
    selector: 'app-image-selector',
    templateUrl: './image-selector.component.html',
})
export class ImageSelectorComponent implements ControlValueAccessor {
    public acceptedImageExtensions = FormService.acceptedImageExtensions;
    public readonly defaultImagePath = input.required<string>();
    public readonly imageUrl: WritableSignal<string> = signal('');
    public readonly isAvatar = input<boolean>(false);
    public readonly isDefaultImage = computed(() => this.imageUrl() === this.defaultImagePath());

    public onChange = (value: string | null): string | null => value;
    public onTouch = (): void => {};

    public registerOnChange(fn: (value: string | null) => string | null): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouch = fn;
    }

    public async updateImage(files: FileList | null): Promise<void> {
        if (!files?.length) {
            this.imageUrl.set(this.defaultImagePath());
            this.onChange(null);

            return;
        }

        const file = files.item(0)!;

        const base64 = await FileService.convertToBase64(file);
        this.onChange(base64);
        this.imageUrl.set(base64);
    }

    public writeValue(image: string | null): void {
        this.imageUrl.set(image ?? this.defaultImagePath());
    }
}
